import axios from "axios";
import { UPDATE_IDENTIFY } from "./actionTypes";

export const identify = (url, webshop_token, IPv4, lang) => (dispatch) => {
  const requestData = {
    url: url,
    webshop_token: webshop_token,
    ip_address: IPv4,
    language: lang,
  };

  const header = {
    Token: "",
    Authorization: "",
  };

  return axios
    .post("/identify", requestData, { headers: header })
    .then((response) => {
      return dispatch({
        type: UPDATE_IDENTIFY,
        payload: {
          //theme: "https://easyapp.bestelsysteem.net/react.css", // ! statische build (vercel)
          theme: "https://" + window.location.hostname + "/react.css", // ! dynamische build
          // theme: "https://" + window.BASE_URL + "/react.css",
          ...response.data.data,
        },
      });
    })
    .catch((err) => {
      console.log(
        "[Identify.actions.js] identify|| Could not fetch identify information. Try again later."
      );
    });
};
